import React from 'react';

import Form from '@rjsf/mui';
import { RJSFSchema } from '@rjsf/utils';
import validator from '@rjsf/validator-ajv8';
import { useSnackbar } from 'notistack';
import fileDownload from 'react-file-download';

import { Box, Button } from '@mui/material';

import { downloadCarHirePaymentStatusReport } from '~/services/ReportingService';
import { formatDateISO, startOfMonth, subMonths } from '~/services/TimeService';

const formSchema: RJSFSchema = {
  description: 'Please enter a range that contains your payment made date to export the Car Hire Payments report',
  type: 'object',
  properties: {
    startAt: {
      title: 'Select Start Date',
      type: 'string',
      format: 'date',
    },
    endAt: {
      title: 'Select End Date',
      type: 'string',
      format: 'date',
    },
    fileFormat: {
      type: 'string',
      title: 'File Format',
      enum: ['csv', 'email'],
    },
  },
};

const formData = {
  startAt: formatDateISO(startOfMonth(subMonths(1))),
  endAt: formatDateISO(startOfMonth()),
  fileFormat: 'email',
};

const uiSchema = {
  startAt: {
    'ui:widget': 'date',
  },
  endAt: {
    'ui:widget': 'date',
  },
  fileFormat: {
    'ui:widget': 'radio',
  },
};

const ExportCarHirePaymentStatusForm = () => {
  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = (event) => {
    const { startAt, endAt, fileFormat } = event.formData;

    const data = downloadCarHirePaymentStatusReport({ startAt, endAt, fileFormat });

    data
      .then((text) => {
        if (fileFormat !== 'email') {
          const fileName = `car_hire_payment_report_${startAt}_${endAt}.${fileFormat}`;
          fileDownload(text, fileName);
        } else {
          enqueueSnackbar(`Your report is queued for delivery and will be emailed shortly.`, { variant: 'success' });
        }
      })
      .catch((err) => {
        enqueueSnackbar(err.message, { variant: 'error' });
      });
  };

  return (
    <Box>
      <Form
        schema={formSchema}
        formData={formData}
        uiSchema={uiSchema}
        validator={validator}
        onSubmit={handleSubmit}
        className="package-form"
      >
        <Button type="submit" variant="contained">
          Download/Email Payment Report
        </Button>
      </Form>
    </Box>
  );
};

export default ExportCarHirePaymentStatusForm;
